export default __webpack_public_path__ + "static/media/character-payment-modal.03a429c4.svg";